
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referenzen/[slug]",
      function () {
        return require("private-next-pages/referenzen/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referenzen/[slug]"])
      });
    }
  